import React from 'react'
import { DI, DIProps } from '../../../../Core';
import { Badge, InlineStack, Text, BlockStack } from '@shopify/polaris';
import { AmazonIcon, ShopifyIcon } from '../../../../Asests/svgIcon/icon';
import { getAmazonStatusBadgeColor, getAmazonStatusBadgeProgress, getShopifyBadgeColor, getShopifyStatusBadgeProgress, getSourceShopID, getStatus } from '../Utils/Helper';

interface props extends DIProps {
    row: any
}
const RenderStatus = (props: props) => {
    const { row } = props;

    /**
     * Renders the Shopify badge based on the provided row data and Shopify status.
     * @param {any} row The row data containing Shopify information.
     * @param {string} shopifyStatus The status of the Shopify order.
     * @returns {React.ReactNode} The JSX representation of the Shopify badge.
     */
    const renderShopifyBadge = (row: any, shopifyStatus: string): React.ReactNode => {
        let renderBadge: React.ReactNode = <></>;
        if (row?.targets) {
            row?.targets?.forEach((target: any) => {
                if (target?.shop_id && target?.shop_id === getSourceShopID(props)) {
                     if (target?.status === "Created" || target?.status === "Shipped" || target?.status === "Partially Shipped")
                        renderBadge = <Badge progress={getShopifyStatusBadgeProgress(target?.status,row)} tone={getShopifyBadgeColor(target?.status,row)}>{shopifyStatus}</Badge>
                    else renderBadge = <Badge tone={getShopifyBadgeColor(target?.status,row)}>{shopifyStatus}</Badge>
                }
            })
        }
        return renderBadge;
    }


    /**
     * Renders the status badge based on the provided row data.
     * @returns {React.ReactNode} The JSX representation of the status badge.
     */
    const renderStatusBadge = (): React.ReactNode => {
        let render: React.ReactNode = <></>;
        let { amazonStatus, shopifyStatus } = getStatus(row, props);

        render = <BlockStack gap="200">
            <InlineStack gap="200" blockAlign='center' wrap={false}>
                <AmazonIcon />
                {
                    (row?.marketplace_status === "Unshipped" || row?.marketplace_status === "Shipped" || row?.marketplace_status === "Partially Shipped") ?
                        <Badge progress={getAmazonStatusBadgeProgress(row?.marketplace_status)} tone={getAmazonStatusBadgeColor(row?.marketplace_status)}>
                            {amazonStatus}
                        </Badge>
                        : <Badge tone={getAmazonStatusBadgeColor(row?.marketplace_status)}>{amazonStatus}</Badge>
                }
            </InlineStack>
            <InlineStack gap="200" blockAlign='center' wrap={false}>
                <ShopifyIcon />
                {shopifyStatus == "-" ? <Text as="span" tone='subdued'>-</Text> : renderShopifyBadge(row, shopifyStatus)}
            </InlineStack>
        </BlockStack>

        return render;
    }

    return (
        <React.Fragment>
            {renderStatusBadge()}
        </React.Fragment>
    )
}

export default DI(RenderStatus)